export default require("./node_modules/vue-i18n/dist/vue-i18n.cjs.js");